import { IconButton } from "@mui/material";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { Fragment } from "react";

export default function FiltersApplied(props: any) {
  return (
    <Fragment>
      {/* SHOWS ONLY IF PROPS.FILTERSVALUES EXISTS AND IS NOT EMPTY */}
      {props.filtersValues.length > 0 && (
        <div className="filtersApplied">
          {props.filtersValues.map((filter:any, index:any) => {
            //if value is longer than 10 characters, cut it
            let value = (filter.value.length < 10) ? filter.value : filter.value.substring(0, 10) + "...";

            return (
              <div className="filterItem" key={index}>
                <span>{value}</span>
                <IconButton
                  size="small"
                  onClick={() => {
                    const newFiltersValues = props.filtersValues.filter((_:any, i:any) => i !== index);
                    props.setFiltersValues(newFiltersValues);
                  }}
                >
                  <DeleteOutlineOutlinedIcon sx={{ fontSize: 15 }} />
                </IconButton>
              </div>
            )
          })}
        </div>
      )}
    </Fragment>
  );
}
